var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
import { isPast, parseJSON } from 'date-fns';
let JobMaterialList = class JobMaterialList extends Vue {
    id = this.$route.params.id;
    search = '';
    filter = [];
    jobs = [];
    loading = true;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = 5000;
    color = "";
    pdf = new Blob();
    headers = [
        { text: 'Auftragsnummer', align: 'start', sortable: true, value: 'id' },
        { text: 'Ordernummer', sortable: true, value: 'order_nr', },
        { text: 'Artikel', sortable: true, value: 'article' },
        { text: 'Kunde', sortable: true, value: 'customer' },
        { text: 'Lieferdatum', sortable: true, value: 'delivery_date' },
        { text: 'Endkontrolle', sortable: true, value: 'final_control' },
        { text: 'index', sortable: true, value: 'index' },
        { text: 'Notiz', sortable: true, value: 'note' },
    ];
    getJobList() {
        this.loading = true;
        this.setFilter('type', this.$attrs.type);
        this.setFilter('search', this.search);
        axios.get('/api/jobs/material', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.jobs = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.jobs;
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    isPast(item) {
        return isPast(parseJSON(item));
    }
    watchOptions() {
        this.getJobList();
        this.$store.state.monitor = false;
    }
    watchSearch() {
        this.getJobList();
        this.$store.state.monitor = false;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getJobList();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], JobMaterialList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], JobMaterialList.prototype, "watchSearch", null);
JobMaterialList = __decorate([
    Component({
        name: "JobMaterialList",
    })
], JobMaterialList);
export default JobMaterialList;
